import timeActions from '../actions/TimeActions';

export default function (
    state = {},
    {
        endTime,
        finalMinutesMode,
        pendingResumeNavigation,
        pauseTime,
        remainingTimePrimaryEndTime,
        testDuration,
        testDurationUsed,
        timeRemaining,
        timeRemainingFetchedFromServer,
        timeRemainingFetchedFromServerAt,
        timeRemainingSetAt,
        type,
    }
) {
    switch (type) {
    case timeActions.types.TIME_SET_TIME_REMAINING:
        return Object.assign({}, state, {
            timeRemaining,
            timeRemainingSetAt,
        });

    case timeActions.types.TIME_SET_TIME_REMAINING_FETCHED_FROM_SERVER:
        return Object.assign({}, state, {
            endTime,
            pauseTime,
            remainingTimePrimaryEndTime,
            testDuration,
            testDurationUsed,
            timeRemaining,
            timeRemainingFetchedFromServer,
            timeRemainingFetchedFromServerAt,
            timeRemainingSetAt,
        });

    case timeActions.types.TIME_SET_PAUSE_TIME:
        return Object.assign({}, state, {
            pauseTime,
        });

    case timeActions.types.TIME_SET_LAST_MINUTES_MODE:
        return Object.assign({}, state, { finalMinutesMode });

    case timeActions.types.TIME_SET_PENDING_RESUME_NAVIGATION:
        return Object.assign({}, state, { pendingResumeNavigation });

    default:
        return state;
    }
}
